var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSliderEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12H9.76983",
    stroke: "#111D43",
    strokeOpacity: 0.4,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.93245 9.31028L0.916016 10.1682L1.78004 7.14566L7.60224 1.31429C7.70126 1.21469 7.819 1.13564 7.94868 1.0817C8.07836 1.02777 8.21743 1 8.35788 1C8.49833 1 8.63739 1.02777 8.76707 1.0817C8.89675 1.13564 9.01449 1.21469 9.11351 1.31429L9.76076 1.96154C9.86268 2.06082 9.94369 2.1795 9.999 2.31059C10.0543 2.44168 10.0828 2.58252 10.0828 2.72481C10.0828 2.86709 10.0543 3.00793 9.999 3.13902C9.94369 3.27011 9.86268 3.3888 9.76076 3.48807L3.93245 9.31028Z",
    stroke: "#111D43",
    strokeOpacity: 0.4,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89973 4.34309L6.74121 2.18457",
    stroke: "#111D43",
    strokeOpacity: 0.4,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSliderEdit);
export default __webpack_public_path__ + "static/media/ic-slider-edit.b488063e08a7fad91ad89a77f3912136.svg";
export { ForwardRef as ReactComponent };